(function () {
    'use strict';

   
    angular
        .module('trainingSchedule')
        .factory('AssignExternalTraineesFactory', AssignExternalTraineesFactory);
    function AssignExternalTraineesFactory() {
        
    	function ExternalTraineeDTO() {
    		this.index = null;
            this.name=null;
            this.id = null;
            this.crewType = null;
            this.institute = null;
            this.trainingSlotId = null;
        }
    	
    	function ExternalTraineeSaveDTO() {
            this.name=null;
            this.id = null;
            this.crewType = null;
            this.institute = null;
            this.trainingSlotId = null;
            this.instituteId = null;
        }
    	
    	function ExternalTraineeSaveRequestDTO() {
            this.externalTrainees=[];
        }
    	
     	function GetEmptyExternalTraineeDTO(){
    		 return new ExternalTraineeDTO();
    	}
    	 
    	function ToExternalTraineeDTO(data,index,trainingSlotId) {
    		var externalTrainee = new ExternalTraineeDTO();
    		externalTrainee.name = data.name;
    		externalTrainee.id = data.id;
    		externalTrainee.crewType = data.crewType;
    		externalTrainee.institute = data.institute;
    		externalTrainee.index = index;
    		externalTrainee.trainingSlotId = trainingSlotId;
            return externalTrainee;
    	}

    	function PopulateExternalTraineeSaveRequest(externalTraineeList){
    		var saveRequest = new ExternalTraineeSaveRequestDTO();
    		angular.forEach(externalTraineeList, function (ext) {
    			var externalTrainee = new ExternalTraineeSaveDTO();
        		externalTrainee.name = ext.name;
        		externalTrainee.id = ext.id;
        		externalTrainee.crewType = ext.crewType.crewTypeCode;
        		externalTrainee.institute = ext.institute.airlineCode;
        		externalTrainee.trainingSlotId = ext.trainingSlotId;
        		externalTrainee.instituteId = ext.institute.airlineId;
        		
        		saveRequest.externalTrainees.push(externalTrainee);
 	        });
 	        return saveRequest;
    		
    	}
    	
        return {
        	getEmptyExternalTraineeDTO : GetEmptyExternalTraineeDTO,
        	toExternalTraineeDTO : ToExternalTraineeDTO,
        	populateExternalTraineeSaveRequest : PopulateExternalTraineeSaveRequest
        }
        
    }
})();